import { render, staticRenderFns } from "./CooperationDetail.vue?vue&type=template&id=6759f162&scoped=true&"
import script from "./CooperationDetail.vue?vue&type=script&lang=js&"
export * from "./CooperationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6759f162",
  null
  
)

export default component.exports